module.exports = __webpack_public_path__ + "img/22_u30.95a8972c.svg";